const userRoutes = {
    sign_in: "/sign-in",
    sign_up: "/sign-up",
    otp_verify: "/verify-otp",
    forgot_otp_verify: "/verify-forgot-password-otp",
    otp_resend: "/resend-otp",
    sign_out: "/sign-out",
    refresh_token: "/refresh-token",
    o_auth: "/o-auth",
    profile: "/profile",
    notifications: "/notifications",
    count: "/count",
    forgot_password: "/forgot-password",
    confirm_password: "/confirm-password",
    reset_password: "/reset-password",
    addresses: "/addresses",
    slots: "/slots",
    bookings: "/bookings",
    create_payment: "/create-payment-intent",
    cancel_booking: "/cancel",
    chats: "/chats",
    reviews: "/reviews",
    report: "/report",
};
export default userRoutes;
